import React from 'react';
import 'ag-grid-enterprise';
import { Dialog } from '@material-ui/core';
import moment from 'moment';
import VouchersRedeemIcon from '../../../icons/VoucherRedeemIcon';
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '../../../icons/SearchIcon';

const useStyles = makeStyles((theme) => ({
  paper: { minWidth: '680px' },
}));

function RewardsTable({ rowData, show, dialogOpen, userGroup, name }) {
  const [searchData, setSearchData] = React.useState([]);
  const classes = useStyles();

  const searchVouchers = (e) => {
    if (e.target.value === '') {
      return setSearchData([]);
    }
    const value = e?.target?.value?.toLowerCase();
    const searchValue = rowData.filter((i) => {
      if (i.productName.toLowerCase().includes(value)) {
        return true;
      }
      return false;
    });
    setSearchData(searchValue);
  };

  const data = searchData.length > 0 ? searchData : rowData;
  return (
    <Dialog
      onClose={() => show(false)}
      aria-labelledby='simple-dialog-title'
      open={dialogOpen}
      classes={{ paper: classes.paper }}
    >
      <div
        className='p-6'
        style={{
          width: '690px',
        }}
      >
        <div className='flex pb-4 text-xl'>
          <span className='mr-2'>{`${name}'s`} Redeems</span>
          <span
            className='px-4 text-sm flex items-center justify-center rounded'
            style={{
              background: '#F5F9FF',
              color: '#1C5DDB',
            }}
          >
            {userGroup}
          </span>
        </div>
        <div className='mb-4 pr-4'>
          <SearchIcon iconStyle='w-4 h-4 absolute mt-2 ml-3' />
          <input
            className='rounded-sm w-full p-1 search-icon-refer-earn pl-10'
            style={{
              border: '1px solid #EBEBEB',
              backgroundColor: '#EBEBEB',
            }}
            placeholder='Search ...'
            onChange={searchVouchers}
          />
        </div>
        <div className='flex flex-wrap'>
          {data?.length > 0
            ? data.map((i, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      boxSizing: 'border-box',
                      width: '310px',
                      minWidth: '310px',
                      height: '140px',
                      background: '#FFFFFF',
                      border: '1px solid #D4DCE7',
                      borderRadius: '8px',
                    }}
                    className='p-2 mr-2 mb-2'
                  >
                    <div className='flex justify-end'>
                      <span>
                        <img
                          src={i?.image}
                          alt='AmazonPayIcon'
                          className='w-14 h-10 absolute'
                          style={{
                            marginTop: '-1px',
                            marginLeft: '-250px',
                          }}
                        />
                      </span>
                      <span>
                        ₹{' '}
                        <span className='font-semibold text-xl text-black'>
                          {(
                            Math.round(i?.denomination * 100) / 100
                          ).toLocaleString()}
                        </span>
                      </span>
                    </div>
                    <div className='my-3'>
                      Expires on:{' '}
                      <span className='font-semibold'>
                        {moment(i?.validity).format('DD MMM YYYY')}
                      </span>
                    </div>
                    <div className='flex justify-between'>
                      <div className='block'>
                        <p>Reference Id: {i?.orderId}</p>
                        <p>
                          Gift Card Code:{' '}
                          <span
                            style={{
                              background: 'rgba(106, 106, 106, 0.37)',
                              filter: 'blur(5px)',
                              backdropFilter: 'blur(3px)',
                              overflow: 'hidden',
                            }}
                          >
                            {i?.voucherCode?.slice(0, 11)}
                          </span>
                        </p>
                      </div>
                      <div>
                        <VouchersRedeemIcon />
                      </div>
                    </div>
                  </div>
                );
              })
            : 'No Gift Cards'}
        </div>
      </div>
    </Dialog>
  );
}

export default RewardsTable;
